export const classes = {
  wrapper: 'flex flex-col items-center',
};
